import { Component } from '@angular/core';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html'
})
export class ListComponent {
  queryParams = { 'name': 'test' };
  isHorizontal = true as boolean;
}
